import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BillFeeForm from "./BillFeeForm";
import { closeModalDialog } from "../../../../../actions/layoutActions";
import propTypes from "../../../../../constants/propTypes";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../actions/dataComponentActions";

import { handleRequestError } from "../../../../../utils/formValidationUtils";
import { processUpsertRequestStatus } from "../../../../../utils/dataComponentUtils";
import { useDatacomponent } from "../../../../hooks/useDatacomponent";
import { getEndOfDayInTimezone } from "../../../../../utils/timezoneUtils";

const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  dataComponentId,
  closeModalDialog,
  setReload,
  formikActions
) => {
  processUpsertRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

const BillFeeContainer = props => {
  const {
    dataComponentId,
    closeModalDialog,
    setReload,
    fee,
    performUpdateRequest,
    timezone,
  } = props;
  const dataComponent = useDatacomponent(dataComponentId);
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      dataComponentId,
      closeModalDialog,
      setReload,
      formikActions
    );
  });

  const handleBillFee = useCallback(
    (
      { revenueSharingProject, workScope, project, feeSubScope, ...fee },
      formikActions
    ) => {
      performUpdateRequest(dataComponentId, fee.id, fee);
      setFormikAction(formikActions);
    },
    [dataComponentId, performUpdateRequest]
  );

  const normalizedBillDate = timezone
    ? getEndOfDayInTimezone(new Date(), timezone)
    : new Date();

  return (
    <BillFeeForm
      initialValues={{
        ...fee,
        invoiceReferenceNumber: "",
        billDate: normalizedBillDate,
        status: "Billed",
      }}
      onSubmit={handleBillFee}
      dataComponentId={dataComponent.dataComponentId}
      timezone={timezone}
    />
  );
};

BillFeeContainer.propTypes = {
  dataComponentId: PropTypes.string.isRequired,
  closeModalDialog: PropTypes.func,
  fee: propTypes.fee,
  performUpdateRequest: PropTypes.func,
  setReload: PropTypes.func,
  timezone: PropTypes.string,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performUpdateRequest,
  setReload,
};

export default connect(null, mapDispatchToProps)(BillFeeContainer);
